<div fxLayout="row" fxLayoutAlign="space-around center" class="container">
  <div fxLayoutAlign="center" class="content-container">
    <ng-content></ng-content>
  </div>
</div>
